import { Grid, Typography, TextField, Button, Link } from "@mui/material";
import colors from "../../../../colors";
import { useDispatch, useSelector } from "react-redux";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import { makeStyles } from "@mui/styles";
import {
  selectUtilityState,
  setSentFrom,
  setExtraInvoiceListData,
  setUtilityName,
} from "../../../../../features/utilities/utilitySlice";
import {
  selectMyContractsState,
  setShouldFillFields,
} from "../../../../../features/myContracts/myContractsSlice";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { texts } from "../../../../general/texts";
import { selectPaymentsState } from "../../../../../features/payments/paymentsSlice";
import SelectCity from "./SelectCity";
import { useEffect } from "react";
import { useState } from "react";

export const Ujesjelles = (props) => {
  const dispatch = useDispatch();
  const utilitySliceState = useSelector(selectUtilityState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const navigate = useNavigate();
  const paymentsSliceState = useSelector(selectPaymentsState);
  const ukSubUtilities = paymentsSliceState.ujesjellesSubUtilities;
  const [state, setState] = useState({
    token: props.globalDataSliceState.token,
    selectedSearchMethod: texts["title-contract"],
    contractNo: "",
    serie: "",
    service: "",
    search: "",
  });

  const handleTextFieldChange = (prop) => (e) => {
    setState({
      ...state,
      [prop]: e.target.value,
    });
  };

  useEffect(() => {
    if (myContractsSliceState.shouldFillFields) {
      setState({
        ...state,
        contractNo: props.selectedContractInfo.contract,
        service: props.selectedContractInfo.service,
      });
      dispatch(setShouldFillFields(false));
    }
  }, [myContractsSliceState.shouldFillFields]);

  const handleButtonClick = (sentFrom) => {
    dispatch(setExtraInvoiceListData({ contractNumber: state.contractNo }));
    if (sentFrom === "contractList") {
      dispatch(
        sendGeneralRequest({
          request: state,
          baseUrlKey: "services",
          endpoint: "UK/GetInvoicesUK",
        })
      );
      dispatch(setUtilityName(state.service));
    } else {
      dispatch(
        sendGeneralRequest({
          request: state,
          baseUrlKey: "services",
          endpoint: "UK/GetInvoiceUK",
        })
      );
    }
    dispatch(setSentFrom(sentFrom));
  };

  const useStyles = makeStyles({
    mainGrid: {
      padding: "5%",
      paddingTop: "3%",
    },
    utilityName: {
      color: colors.orange,
      fontSize: "1.5rem",
      fontFamily: "GerberaBold",
      paddingTop: "3%",
      paddingLeft: "2%",
    },
    headerBox: {
      backgroundColor: colors.cyan,
      borderRadius: "100%",
      width: "70px",
      height: "70px",
    },
    fieldTitle: {
      color: colors.darkBlue,
      fontSize: "1.2rem",
      fontFamily: "GerberaBold",
      textAlign: "left",
    },
    button: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.gradientOrange,
      fontFamily: "GerberaBold",
    },
    buttonGrid: {
      marginTop: 120,
      paddingBottom: 5,
    },
    image: {
      width: "55%",
    },
    textField: {
      width: "100%",
    },
  });

  const classes = useStyles();

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
      <Grid container item md={2} xs={2} mt={2}>
        <Link
          component={"button"}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosNewIcon color="warning" />
        </Link>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.headerBox}
        >
          <img
            src={'https://www.easypay.al/MobileLogos/servicesCategory/water.png'}
            alt="image"
            className={classes.image}
          />
        </Grid>
        <Typography className={classes.utilityName}>
          {props.utilityName}
        </Typography>
      </Grid>
      <Grid container item md={12}>
        <Typography className={classes.fieldTitle}>
          {texts["prompt-choose-search-method"]}
        </Typography>
      </Grid>
      <SelectCity
        state={state}
        handleTextFieldChange={handleTextFieldChange}
        ukSubUtilities={ukSubUtilities}
      />
      <Grid container item md={12} xs={12} rowSpacing={5}>
        <Grid container item md={12} xs={12}>
          <Typography className={classes.fieldTitle}>
            {texts["prompt-search-with-contract-code"]}
          </Typography>
        </Grid>
        <Grid container item md={12} xs={12}>
          <TextField
            onChange={handleTextFieldChange("contractNo")}
            value={state.contractNo}
            color="warning"
            size="small"
            label={texts["placeholder-contract"]}
            className={classes.textField}
          />
        </Grid>
        <Grid container item rowSpacing={3}>
          <Grid item md={12} xs={12} className={classes.buttonGrid}>
            <Button
              disabled={utilitySliceState.isLoading ? true : false}
              onClick={() => {
                handleButtonClick("contractList");
              }}
              className={classes.button}
            >
              {texts["title-search"]}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Ujesjelles;
